module.exports = __webpack_public_path__ + "media/img/pages/companies/carrerplus-144ab086a1eb38d387bd337db398ac79.png";